// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDbknwb-HMPXVCySVEWWg-nNdxqNbU3OhI",
    authDomain: "geoksiegi.firebaseapp.com",
    projectId: "geoksiegi",
    storageBucket: "geoksiegi.firebasestorage.app",
    messagingSenderId: "130445969237",
    appId: "1:130445969237:web:c53e36d3eed8b64a7b11dc"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const firestoreDb = getFirestore(firebaseApp);
